import { Component } from 'react'

export default class Landing extends Component {
  render () {
    return null
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/index.js